import * as React from "react";
import "./User.scss";
import { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import { Button, Input, Modal, Progress, Spin } from "antd";
import moment from "moment";

import dayjs from "dayjs";
import Swal from "sweetalert2";

import partnersApi from "../../apis/Partners.api";
import { setUser } from "../../redux/store/auth/authDuck";
import { setLoading } from "../../redux/store/common/commonDuck";
import PersonalAuthentication from "../common/PersonalAuthentication";
import ScreenLoading from "../common/ScreenLoading";

import SignUpHeader from "./SignUpHeader";

/**
 * 등급 이름 변경
 * @param grade
 * @returns {string|null}
 */
const handleGradeName = (grade) => {
	return grade === "grade_1" || grade === "super_admin"
		? "PREMIUM"
		: grade === "grade_2"
		? "FAMILY"
		: grade === "grade_3"
		? "HELLO"
		: null;
};

/**
 * grade 수준 나누기, 크면 true, 작으면 false
 * @param main
 * @param compare
 * @returns {boolean}
 */
const isBigBetweenGrade = (main, compare) => {
	function gradeLevel(grade) {
		if (grade === "HELLO") {
			return 1;
		} else if (grade === "FAMILY") {
			return 2;
		} else if (grade === "PREMIUM") {
			return 3;
		} else return 0;
	}

	return gradeLevel(main) > gradeLevel(compare);
};

const SellerMyGrade = () => {
	const user = useSelector((state) => state.auth.user);
	const dispatch = useDispatch();

	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const grade = handleGradeName(user.grade);

	const [gradeInfo, setGradeInfo] = useState({});
	const [show, setShow] = useState(false);

	useLayoutEffect(() => {
		if (user.mall_id) {
			readUserData();
		}
	}, []);
	useEffect(() => {
		getSellerInfo();
	}, [user]);

	const readUserData = async () => {
		const param = {
			type: "mallId",
			userId: user?.mall_id,
		};

		const res = await partnersApi.readMallPartnersId(param);
		if (res.code === 200 || res.code === 402) {
			dispatch(setUser(res.result));
		}
	};

	const getSellerInfo = async () => {
		setIsLoading(true);
		let param = {
			type: "sellerInfo",
			userId: user?.id,
		};
		const res = await partnersApi.readMallPartnersId(param);
		if (res.code === 200) {
			let result = res.result;
			let param = {
				additional_sales: result.additional_sales ?? 0,
				total_purchase_amount: result.total_purchase_amount ?? 0,
				goal_grade: result.goal_grade,
				goal: handleGradeName(result.goal_grade),
				next_grade: result.next_grade,
				next: handleGradeName(result.next_grade),
			};
			setGradeInfo(param);
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "오류가 발생했습니다. 잠시 후에 다시 시도해주세요.",
				confirmButtonText: "확인",
			});
		}
		setIsLoading(false);
	};

	return (
		<div style={{ position: "relative" }}>
			{isLoading && <ScreenLoading />}
			{/* 유저 배너 */}
			<SellerUserBanner user={user} grade={grade} gradeInfo={gradeInfo} />
			<div className="main-wrap seller-mygrade-banner">
				<div className={`max-width-apply`}>
					{/* 모바일 헤더 추가 */}
					<SignUpHeader title={"나의 판매자 등급"} />

					<div className={`seller-grade-margin-top-wrap`}>
						{/* 나의 판매자 등급 */}
						<SellerMyGradeBanner grade={grade} />
						{/* 리워드 지급 안내 배너 */}
						<SellerRewardBanner
							grade={grade}
							gradeInfo={gradeInfo}
							user={user}
						/>
					</div>
					{/* 판매자등급 혜택 - 그래프 */}
					<SellerGradeBenefitGraph grade={grade} />
					{/* 판매자등급 혜택 - 리스트 */}
					<SellerBenefitList grade={grade} />
					{/* 판매자 등급 승급 방법 */}
					<SellerHowto />
				</div>

				<Button
					className={`benefit-by-grade-button`}
					onClick={() => setShow(true)}
				>
					<img
						src={`/assets/images/seller/seller_${
							grade === "HELLO" ? 1 : grade === "FAMILY" ? 2 : 3
						}.png`}
						alt={`등급별 혜택 보기`}
					/>
					등급별 혜택 보기
				</Button>
				<SellerGradeModal show={show} setShow={setShow} />
			</div>
		</div>
	);
};

// 유저 배너
const SellerUserBanner = ({ user, grade, gradeInfo }) => {
	const [certifiedData, setCertifiedData] = useState({});
	const history = useHistory();
	const historyRouting = () => {
		history.push(`/user/mypage`);
	};

	const gradeProfile =
		grade === "HELLO"
			? "seller_3"
			: grade === "FAMILY"
			? "seller_2"
			: "seller_1";

	// 추가 판매가 필요 없는 상황 boolean
	// 현재 grade와 next가 같지 않으면서, next가 현재보다 높을 때
	const isNextGrade =
		isBigBetweenGrade(gradeInfo.next, grade) && grade !== gradeInfo.next;

	// 문구 표기
	// 1. 프리미엄인지 아닌지
	// 1-1. 프리미엄 등급에 매출액이 도달 했는지
	// 2. 다음 목표에 달성 했는지 (isNextGrade)
	// 2-1. 달성한 목표가 프리미엄인지
	return (
		<div className={`seller-user-banner-wrap`}>
			<div className={`main-wrap`}>
				<div className={`max-width-apply`}>
					{/*<PersonalAuthentication*/}
					{/*	certifiedData={certifiedData}*/}
					{/*	setCertifiedData={setCertifiedData}*/}
					{/*/>*/}
					<div className={`seller-grade-user-info`}>
						<div className={`seller-profile`}>
							<img
								src={`/assets/images/seller/${gradeProfile}.png`}
								alt={`nice_icon`}
							/>
						</div>
						<div className={`seller-user-div`}>
							<div
								style={{ display: "flex", alignItems: "center", gap: "0.3em" }}
							>
								<h1>{user.nickname}</h1>
								<button className={`seller-setting`} onClick={historyRouting}>
									<img
										src={`/assets/images/login/setting.png`}
										alt={`로그인 설정`}
									/>
								</button>
							</div>
							<div
								style={{ display: "flex", alignItems: "baseline", gap: "1em" }}
							>
								<h2>{grade}</h2>
								{/*{user?.signup_date && (*/}
								{/*	<p>가입일: {moment(user.signup_date).format("YYYY.MM.DD")}</p>*/}
								{/*)}*/}
							</div>
							{/* 1. 프리미엄인지 아닌지 */}
							{grade === "PREMIUM" ? (
								// 1-1. 프리미엄 등급에 매출액이 도달 했는지
								gradeInfo.additional_sales > 0 ? (
									<p className={`banner-text-pc`}>
										{gradeInfo?.additional_sales?.toLocaleString()}원 추가
										판매하여,{"\n"}계속해서 <span>PREMIUM</span> 등급을
										지켜주세요!
									</p>
								) : (
									<p className={`banner-text-pc`}>
										이번달에도 <span>PREMIUM</span> 등급을 달성하셨네요~{"\n"}
										정말 대단하세요! 앞으로도 <span>PREMIUM</span> 등급을
										지켜주세요!
									</p>
								)
							) : // 2. 다음 목표에 달성 했는지
							isNextGrade ? (
								// 2-1. 달성한 목표가 프리미엄인지
								gradeInfo.next !== "PREMIUM" ? (
									<p className={`banner-text-pc`}>
										<span>{gradeInfo?.next}</span> 등급을 달성하셨어요!{"\n"}
										정말 축하드립니다~ <span>{gradeInfo?.goal}</span> 등급
										달성까지 힘내봐요!
									</p>
								) : (
									<p className={`banner-text-pc`}>
										<span>{gradeInfo?.next}</span> 등급을 달성하셨어요!{"\n"}
										앞으로도 <span>{gradeInfo?.next}</span> 등급을 지켜주세요!
									</p>
								)
							) : (
								<p className={`banner-text-pc`}>
									{gradeInfo?.additional_sales?.toLocaleString()}원 추가 판매 시{" "}
									<span>{gradeInfo?.goal}</span> 달성!
								</p>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

// 나의 판매자 등급
const SellerMyGradeBanner = ({ grade }) => {
	return (
		<div className={`seller-my-grade-banner`}>
			<h1 className={`seller-grade-title-text`}>나의 판매자 등급</h1>
			<p className={`my-grade`}>{grade}</p>
		</div>
	);
};

// 리워드 지급 안내 배너
const SellerRewardBanner = ({ grade, gradeInfo, user }) => {
	const [mediaResult, setMediaResult] = useState(null);

	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	const [progress, setProgress] = useState(0);

	useEffect(() => {
		let total = gradeInfo.total_purchase_amount ?? 0;
		let min = mediaResult ? 8 : 6;

		if (gradeInfo.next === "HELLO") {
			// 500만원 마다 변경
			let count = Math.trunc(total / 5000000) * 7.5;
			setProgress(count + min);

			// let min = mediaResult ? 8 : 16;
			// let count = (total / 30000000) * (50 - min);
			// setProgress(count + min);
		} else if (gradeInfo.next === "FAMILY") {
			// 500만원 마다 변경
			total -= 30000000;
			let count = Math.trunc(total / 5000000) * 12.5;
			setProgress(count + min + 45);

			// let min = 2;
			// total -= 30000000;
			// let count = (total / 20000000) * (40 - min);
			// setProgress(60 + count);
		} else {
			setProgress(100);
		}
	}, [mediaResult, gradeInfo]);

	//user.signup_date
	let signupDate = dayjs(user?.signup_date).format("YYYY-MM-DD");
	let endDate = dayjs(signupDate).add(2, "month").format("YYYY-MM-DD");

	return (
		<div className={`seller-my-grade-banner`}>
			<h1 className={`seller-grade-title-text reward`}>
				상품별 최대{" "}
				<span>
					{grade === "HELLO" ? "10" : grade === "FAMILY" ? "20" : "30"}%
				</span>{" "}
				리워드 지급
			</h1>
			<div className={`seller-reward-progress-wrap`}>
				<div className={`reward-progress-grade-wrap`}>
					{dayjs().isAfter(endDate, "month") ? (
						<p>다음달 예상등급 {gradeInfo?.next}</p>
					) : (
						<p>첫 가입 후 3달간은 {grade} 예요</p>
					)}
				</div>
				<div className={`progress-wrap`}>
					<Progress percent={progress} className={`reward-progress`} />
					<div className={`grade-point-wrap`} id={`hello`}>
						<div className={`grade-point ${progress >= 6 && "active"}`} />
						{/*<div className={`grade-point ${progress >= 8 && "active"}`} />*/}
					</div>
					<div className={`grade-point-wrap`} id={`family`}>
						<div className={`grade-point ${progress >= 45 && "active"}`} />
						{/*<div className={`grade-point ${progress >= 60 && "active"}`} />*/}
					</div>
					<div className={`grade-point-wrap`} id={`premium`}>
						<div className={`grade-point ${progress === 100 && "active"}`} />
					</div>
				</div>
				<div className={`progress-wrap`}>
					<div className={`grade-point-wrap text`} id={`hello`}>
						<div className={`grade-point-wrap-inner`}>
							<div className={`grade-point-wrap-icon`}>
								<img
									src={`/assets/images/seller/seller_3.png`}
									alt={`유저 아이콘`}
								/>
							</div>
							<p className={`${progress < 60 && "active"}`}>환영합니다</p>
						</div>
					</div>
					<div className={`grade-point-wrap text`} id={`family`}>
						<div className={`grade-point-wrap-inner`}>
							<div className={`grade-point-wrap-icon`}>
								<img
									src={`/assets/images/seller/seller_2.png`}
									alt={`유저 아이콘`}
								/>
							</div>
							<p className={`${progress >= 60 && progress < 100 && "active"}`}>
								3,000만원
							</p>
						</div>
					</div>
					<div className={`grade-point-wrap text`} id={`premium`}>
						<div className={`grade-point-wrap-inner`}>
							<div className={`grade-point-wrap-icon`}>
								<img
									src={`/assets/images/seller/seller_1.png`}
									alt={`유저 아이콘`}
								/>
							</div>
							<p className={`${progress === 100 && "active"}`}>5,000만원</p>
						</div>
					</div>
				</div>
			</div>
			<p className={`reward-purchase-amount`}>
				구매금액 {gradeInfo.total_purchase_amount?.toLocaleString() ?? 0}원
			</p>
			<p className={`grade-period-text`}>
				실적 기간 (
				{moment().subtract(3, "month").startOf("months").format("YY년 M월 D일")}
				~{moment().subtract(1, "month").endOf("months").format("YY년 M월 D일")})
			</p>
			<div className={`reward-purchase-history-wrap`}>
				<Link to={`/reports`}>상세 구매내역 보기</Link>
				<p>* 최근 3개월 판매 금액 기준으로 업데이트 됩니다</p>
			</div>
		</div>
	);
};

// 판매자등급 혜택 - 그래프
const SellerGradeBenefitGraph = ({ grade }) => {
	return (
		<div className={`seller-grade-each-wrap`}>
			<div className={`seller-grade-benefit`}>
				<div className={`grade-information-div`} style={{ padding: 0 }}>
					<b className={`grade-target-text`}>판매자등급 혜택</b>
					<p className={`grade-next-month`} style={{ color: "#9d9d9d" }}>
						HELLO > FAMILY > PREMIUM
					</p>
				</div>
				<div className={`grade-benefit-graph-list`}>
					<div
						className={`grade-benefit-graph-each hello ${
							grade === "HELLO" && "active"
						}`}
					>
						<img src={`/assets/images/seller/HELLO.png`} alt={`HELLO`} />
						<div className={`grade-benefit-each-bar-graph`} />
						<p>HELLO</p>
					</div>
					<div
						className={`grade-benefit-graph-each family ${
							grade === "FAMILY" && "active"
						}`}
					>
						<img src={`/assets/images/seller/FAMILY.png`} alt={`FAMILY`} />
						<div className={`grade-benefit-each-bar-graph`} />
						<p>FAMILY</p>
					</div>
					<div
						className={`grade-benefit-graph-each premium ${
							grade === "PREMIUM" && "active"
						}`}
					>
						<img src={`/assets/images/seller/PREMIUM.png`} alt={`PREMIUM`} />
						<div className={`grade-benefit-each-bar-graph`} />
						<p>PREMIUM</p>
						<img
							id={`crown`}
							src={`/assets/images/seller/crown.png`}
							alt={`crown`}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

// 판매자등급 혜택 - 리스트
const SellerBenefitList = ({ grade }) => {
	const benefits =
		grade === "HELLO"
			? ["상품별 리워드 최대 10%"]
			: grade === "FAMILY"
			? ["상품별 리워드 최대 20%", "약 30만원 상당의 바우처 지급\n(1인 식사권)"]
			: [
					"상품별 리워드 최대 30%",
					"약 50만원 상당의 바우처 지급\n(호텔 1박 숙박권)",
			  ];
	const condition =
		grade === "HELLO"
			? "가입 즉시"
			: grade === "FAMILY"
			? "최근 3개월 기준 판매액 3천만원 이상"
			: "최근 3개월 기준 판매액 5천만원 이상";

	return (
		<div className={`seller-grade-each-wrap`}>
			<div className={`seller-benefit-list`}>
				<h3>{grade}</h3>
				<div className={`seller-benefit-list-detail`}>
					<p className={`detail-label`}>혜택</p>
					<div className={`detail-body-div`}>
						{benefits?.map((item, idx) => (
							<p key={`seller-benefit-${idx}`} className={`detail-body-text`}>
								{item}
							</p>
						))}
					</div>
				</div>
				<div className={`seller-benefit-list-detail`}>
					<p className={`detail-label`}>기준</p>
					<div className={`detail-body-div`}>
						<p className={`detail-body-text`}>{condition}</p>
					</div>
				</div>
			</div>
		</div>
	);
};

// 판매자 등급 승급 방법
const SellerHowto = () => {
	return (
		<div className={`seller-grade-each-wrap`}>
			<div className={`seller-grade-benefit`}>
				<b className={`howto-text`}>판매자 등급 승급 방법?</b>
				<p className={`howto-text`}>
					최근 3개월 기준 판매 금액 기준으로 판매자 등급의 승급이 자동으로
					변경되요
				</p>
				<br />
				<p className={`howto-text`}>
					<span>매달 승급의 기회</span>가 주어집니다^^
				</p>
				{/*<p className={`howto-text`}>판매자 등급 변경 시 알림이 도착해요</p>*/}
			</div>
		</div>
	);
};

const SellerGradeModal = ({ show, setShow }) => {
	const gradeList = ["HELLO", "FAMILY", "PREMIUM"];
	const imgList = ["seller_3", "seller_2", "seller_1"];
	const benefits = [
		["상품별 리워드 최대 10%"],
		["상품별 리워드 최대 20%\n약 30만원 상당의 바우처 지급 (1인 식사권)"],
		["상품별 리워드 최대 30%\n약 50만원 상당의 바우처 지급 (호텔 1박 숙박권)"],
	];
	const condition = [
		"가입 즉시",
		"최근 3개월 기준 판매액 3천만원 이상",
		"최근 3개월 기준 판매액 5천만원 이상",
	];
	return (
		<Modal
			title="판매자등급 혜택"
			wrapClassName="seller-grade-modal-wrap"
			open={show}
			onCancel={() => setShow(false)}
			footer={<></>}
			centered={true}
		>
			<div className={`seller-grade-modal-div`}>
				{gradeList?.map((grade, idx) => (
					<div key={idx} className={`seller-grade-modal-each`}>
						<div className={`seller-grade-modal-info`}>
							<p className={`title`}>{grade}</p>
							<div className={`seller-grade-modal-info-benefit-div`}>
								<label>혜택</label>
								<p className={`value`}>{benefits[idx]}</p>
							</div>
							<div className={`seller-grade-modal-info-benefit-div`}>
								<label>기준</label>
								<p className={`value`}>{condition[idx]}</p>
							</div>
						</div>
						<img
							src={`/assets/images/seller/${imgList[idx]}_text.png`}
							alt={imgList[idx]}
						/>
					</div>
				))}
			</div>
		</Modal>
	);
};

export default SellerMyGrade;
